<template>
    <div></div>
</template>

<script>
    import Plot from "../services/plot"

    export default {
        name: "SearchMapRedirect",
        async created() {
            let hash = this.$route.query["hash"];
            let delegation = +this.$route.query["delegation"] || 0;
            let url = await Plot.vesselMapUrl(hash, delegation);
            for (let field of Object.getOwnPropertyNames(this.$route.query)) {
                if (field !== "hash" && field !== "delegation") {
                    url += `&${field}=${encodeURIComponent(this.$route.query[field])}`;
                }
            }
            this.$router.replace(url);
        },
    }
</script>

<style scoped>

</style>